module.exports = __webpack_public_path__ + "static/media/canvas.26c20ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bcase/assets/canvas.png
// module id = 2607
// module chunks = 0